import {AutoDeliveryDcxActiveInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxActive/AutoDeliveryDcxActiveInfoBox';

import AutoDeliveryDcxDetailsMobile from '../components/AutoDeliveryDcxDetailsMobile';
import useAutoDeliveryDcxDetails from '../hooks/useAutoDeliveryDcxDetails';
import StatusActiveRescheduleButton from './StatusActiveRescheduleButton';
import StatusActiveSkipButton from './StatusActiveSkipButton';

const StatusActiveMobile = () => {
    const details = useAutoDeliveryDcxDetails();
    const {
        autoDelivery: {isFreezed},
    } = details;

    return (
        <AutoDeliveryDcxDetailsMobile
            status='active'
            orderDetailsExtraSection={<AutoDeliveryDcxActiveInfoBox className='mt-4' details={details} />}
            showNextDeliveryHero
            footerActions={
                !isFreezed ? (
                    <>
                        <StatusActiveRescheduleButton className='mt-0' />
                        <StatusActiveSkipButton className='mt-0 self-center' />
                    </>
                ) : undefined
            }
        />
    );
};

export default StatusActiveMobile;
